import React, { useCallback, useEffect, useState } from 'react';
import {
	List,
	ListItem as MuiListItem,
	Typography,
	Collapse,
	Box
} from '@mui/material';
import { ExpandMore, ChevronRight } from '@mui/icons-material';

type Props = {
	label: string;
	children: JSX.Element;
};

const ExpandableListItem: React.FC<Props> = ({ children, label }) => {
	const [open, setOpen] = useState(true);
	const onClick = useCallback(() => setOpen((state) => !state), [setOpen]);

	useEffect(() => {
		setOpen(true);
	}, [children]);

	return (
		<Box marginTop={1}>
			<MuiListItem button onClick={onClick}>
				{!open ? <ChevronRight /> : <ExpandMore />}
				<Typography
					variant="subtitle2"
					sx={{ textTransform: 'uppercase', marginLeft: 1 }}
				>
					{label}
				</Typography>
			</MuiListItem>
			<Collapse in={open} timeout="auto" unmountOnExit>
				<List component="ul" disablePadding sx={{ listStyleType: 'disc' }}>
					{children}
				</List>
			</Collapse>
		</Box>
	);
};

export default ExpandableListItem;
